// @flow

// Effect Managers
import {
  call,
  fork,
  take,
  select,
} from 'redux-saga/effects'

// Selector
import { firstAvailableGrowerId$ } from 'fc-assets'
import operations$ from '../selectors/operations'

// Controller
import fertilizerController from 'fc-ctrl-fertilizers'
import assetsCtrl from 'fc-ctrl-assets'

// Sagas
import watchAssetOperations from './operations'
import { watchOperations } from 'hfty-operator-fertilizers'

// Constants
import { FETCH_FERTILIZERS } from '../constants'

// Sagas
export default function *main (): Generator<*, *, *> {
  yield call(fertilizerController.start)
  yield call(fertilizerController.start)
  yield fork(fertilizerController.watch)
  yield fork(watchAssetOperations)
  yield fork(watchOperations, { operations$ })
  yield fork(watchFetchFertilizers)
}

export function *watchFetchFertilizers (): Generator<*, *, *> {
  while (true) {
    yield take(FETCH_FERTILIZERS)
    let growerId = yield select(firstAvailableGrowerId$)

    while (!growerId) {
      yield take(assetsCtrl.actionTypes.receive())

      growerId = yield select(firstAvailableGrowerId$)
    }

    yield call(fertilizerController.read, {
      queryParams: {
        hefty: 'True',
        asset: growerId,
      },
    })
  }
}
